import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getEvaluations = (params) => async (dispatch) => {
    dispatch({ type: 'EVALUATIONS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/evaluations', {
            params,
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'EVALUATIONS_SUCCESS', payload: data.evaluations })
        }
    } catch (error) {
        dispatch({ type: 'EVALUATIONS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const addEvaluation = (evaluation) => async (dispatch) => {
    dispatch({ type: 'EVALUATIONS_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/teacher/evaluations', evaluation, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'EVALUATION_ADD_SUCCESS', payload: data.evaluation })
        }
    } catch (error) {
        dispatch({ type: 'EVALUATIONS_ERROR', payload: error.response?.data?.message || error.message })
    }
}
